<template>
  <div class="container-xxl">
    <titulo-grande texto="Meus dados" posicao="left" />

    <modal tituloModal="Alterar senha" @fecha_modal="fecha_modal" @hidden="fecha_modal" textoBtnChamada="Alterar senha"
      tamanho_modal="modal-md" :exibe_botao="true" alinhaBtn="end" id_modal="modal_change_pass">
      <template #default>
        <InputText classDiv="col-12" tipo="password" :btn_lock="true" label="Senha atual *" tamanho="sm" nome="old_pass" ref="old_pass"
          :ativa_placeholder="load_dados" v-model="password.old_pass" />
        <InputText classDiv="col-12" tipo="password" :btn_lock="true" label="Nova senha *" tamanho="sm" nome="new_pass" ref="new_pass"
          :ativa_placeholder="load_dados" v-model="password.new_pass" />
        <InputText classDiv="col-12" tipo="password" :btn_lock="true" label="Repita Nova senha *" tamanho="sm" nome="renew_pass"
          ref="renew_pass" :ativa_placeholder="load_dados" v-model="password.renew_pass" />
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="alterar_senha" class="btn btn-primary"><i
              class="bi bi-file-lock2-fill"></i>
            Salvar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <fieldset>
      <div class="col-10 col-md-8 offset-1 offset-md-2 mb-5 shadow p-4 rounded-3">
        <div class="row">
          <InputText classDiv="col-md-6" label="Nome *" tamanho="sm" nome="nome" ref="nome"
            :ativa_placeholder="load_dados" v-model="dados.nome" />
          <InputText classDiv="col-md-6" label="Email" tamanho="sm" nome="email" ref="email"
            :ativa_placeholder="load_dados" v-model="dados.email" />
          <InputTextMask classDiv="col-md-4" mask="cpf" label="CPF" tamanho="sm" nome="cpf" ref="cpf"
            :ativa_placeholder="load_dados" v-model="dados.cpf" />
          <InputTextMask classDiv="col-md-4" mask="rg" label="RG" tamanho="sm" nome="rg" ref="rg"
            :ativa_placeholder="load_dados" v-model="dados.rg" />
          <InputTextMask classDiv="col-md-4" mask="cep" label="CEP" tamanho="sm" nome="cep" ref="cep"
            :ativa_placeholder="load_dados" v-model="dados.cep" />
          <InputText classDiv="col-md-6" label="Endereco" tamanho="sm" nome="endereco" ref="endereco"
            :ativa_placeholder="load_dados" v-model="dados.endereco" />
          <InputText classDiv="col-6 col-md-3" label="Numero" tipo="tel" tamanho="sm" nome="numero" ref="numero"
            :ativa_placeholder="load_dados" v-model="dados.numero" />
          <InputSelect classDiv="col-6 col-md-3" :dados="lista_estados" label="Estado" tamanho="sm" name="estado"
            ref="estado" :ativa_placeholder="load_dados" v-model="dados.estado" />
          <InputText classDiv="col-md-6" label="Complemento" tamanho="sm" nome="complemento" ref="complemento"
            :ativa_placeholder="load_dados" v-model="dados.complemento" />
          <InputText classDiv="col-md-6" label="Bairro" tamanho="sm" nome="bairro" ref="bairro"
            :ativa_placeholder="load_dados" v-model="dados.bairro" />
          <InputText classDiv="col-md-6" label="Cidade" tamanho="sm" nome="cidade" ref="cidade"
            :ativa_placeholder="load_dados" v-model="dados.cidade" />
          <InputTextMask classDiv="col-md-6" label="Telefone" tamanho="sm" nome="telefone" ref="telefone"
            :ativa_placeholder="load_dados" v-model="dados.telefone" />
          <InputMoney classDiv="col-md-6" label="Valor de contribuicao" tamanho="sm" nome="valor_contribuicao"
            ref="valor_contribuicao" :ativa_placeholder="load_dados" v-model="dados.valor_contribuicao" />
          <InputText classDiv="col-md-6" mask="databr" tipo="date" label="Data de vencimento" tamanho="sm"
            nome="data_vencimento" ref="data_vencimento" :ativa_placeholder="load_dados"
            v-model="dados.data_vencimento" />
          <InputSelect classDiv="col-md-6" :dados="lista_sexo" label="sexo" tamanho="sm" name="sexo" ref="sexo"
            :ativa_placeholder="load_dados" v-model="dados.sexo" />
          <InputText classDiv="col-md-6" mask="databr" tipo="date" label="Data de nascimento" tamanho="sm"
            nome="data_nasc" ref="data_nasc" :ativa_placeholder="load_dados" v-model="dados.data_nasc" />
          <InputText classDiv="col-md-6" label="Cidade onde vota" tamanho="sm" nome="cidade_onde_vota"
            ref="cidade_onde_vota" :ativa_placeholder="load_dados" v-model="dados.cidade_onde_vota" />
          <InputSelect classDiv="col-md-6" :dados="lista_estado_civil" label="Estado civil" tamanho="sm"
            name="estado_civil" ref="estado_civil" :ativa_placeholder="load_dados" v-model="dados.estado_civil" />
          <InputText classDiv="col-md-6" tipo="number" label="Quantidade de filhos" tamanho="sm" nome="filhos"
            ref="filhos" :ativa_placeholder="load_dados" v-model="dados.filhos" />
          <InputText classDiv="col-md-6" label="Naturalidade" tamanho="sm" nome="naturalidade" ref="naturalidade"
            :ativa_placeholder="load_dados" v-model="dados.naturalidade" />

          <button class="text-center btn btn-bg btn-info text-light" @click="salvar">Salvar alterações</button>

          <div class="col-12 p-3">
            <TermosAdesao></TermosAdesao>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import InputText from '@/components/form/InputText.vue';
import TituloGrande from '../../components/TituloGrande.vue';
import InputSelect from '@/components/form/InputSelect.vue';
import InputTextMask from '@/components/form/InputTextMask.vue';
import { api } from '@/services/api';
import { AuthStore } from '@/stores/Auth';
import { bloqueia_campos } from '@/assets/js/functions'
import { toastr } from '@/plugins/toast';
import { estados_brasil, estado_civil } from '@/assets/js/dados_json'
import InputMoney from '@/components/form/InputMoney.vue';
import Modal from '@/components/Modal.vue';
import TermosAdesao from '@/components/TermosAdesao.vue';

export default {
  components: { TituloGrande, InputText, InputSelect, InputTextMask, InputMoney, Modal, TermosAdesao },
  name: 'MeusDados',
  data() {
    return {
      auth: AuthStore(),
      dados: {
        nome: '',
        cpf: '',
        rg: '',
        email: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        telefone: '',
        valor_contribuicao: '',
        data_vencimento: '',
        data_nasc: '',
        sexo: '',
        cidade_onde_vota: '',
        estado_civil: '',
        filhos: '',
        naturalidade: '',
      },
      password: {
        old_pass: '',
        new_pass: '',
        renew_pass: ''
      },
      lista_estados: estados_brasil(),
      lista_sexo: [
        { "texto": "Selecione seu sexo", "valor": "" },
        { "texto": "Masculino", "valor": "Masculino" },
        { "texto": "Feminino", "valor": "Feminino" },
      ],
      lista_estado_civil: estado_civil(),
      load_dados: true
    }
  },
  methods: {
    async carrega_usuario() {
      this.dados = await api.get('user/meus_dados', { Authorization: this.auth.token });

      this.load_dados = false
    },
    async busca_cep(cep) {
      this.load_dados = true
      bloqueia_campos()
      const link = 'https://brasilapi.com.br/api/cep/v1/' + cep;

      try {
        var local = await api.fullget(link)
        if (local.status == 200) {
          this.dados.endereco = local.street;
          this.dados.bairro = local.neighborhood;
          this.dados.cidade = local.city;
          this.dados.estado = local.state;
        } else {
          this.dados.endereco = '';
          this.dados.bairro = '';
          this.dados.cidade = '';
          this.dados.estado = '';
        }

      } catch (error) {
        this.dados.endereco = '';
        this.dados.bairro = '';
        this.dados.cidade = '';
        this.dados.estado = '';
        toastr.erro("Erro na solicitação, verifique o cep digitado e tente novamente.")
      }

      this.load_dados = false
      bloqueia_campos(false)
    },
    async salvar() {
      this.load_dados = true
      bloqueia_campos()
      try {
        const data = await api.post('user/save_my_data', this.dados, { Authorization: this.auth.token })
        if (data.status == 200) {
          toastr.sucesso("Dados atualizados com sucesso.")
          this.auth.renewToken()
        } else {
          toastr.erro(data.message)
        }
      } catch (error) {
        toastr.erro(error)
      }
      this.load_dados = false
      bloqueia_campos(false)
    },
    async alterar_senha() {
      if (!this.password.new_pass) {
        toastr.alerta("Digite uma nova senha")
        return false;
      } else
        if (this.password.new_pass.length < 8) {
          toastr.alerta("A nova senha deve ter pelo menos 8 caracteres")
          return false;
        }
      if (this.password.new_pass != this.password.renew_pass) {
        toastr.alerta("As senhas digitadas não conferem.")
        return false;
      }

      bloqueia_campos()
      try {
        const autoriza = await api.autoriza()
        if (autoriza) {
          const data = await api.post('user/change_pass', this.password, { Authorization: this.auth.token })
          if (data.status == 200) {
            toastr.sucesso("Dados atualizados com sucesso.")
            this.password = {}
            document.querySelector("#btn_close_modal_change_pass").click()
            this.auth.renewToken()
          } else {
            toastr.erro(data.message)
          }
        }
      } catch (error) {
        toastr.erro(error)
      }
      this.load_dados = false
      bloqueia_campos(false)
    }
  },
  mounted() {
    this.carrega_usuario()
  },
  watch: {
    'dados.cep'(n, o) {
      if (n.length == 9) {
        this.busca_cep(n)
      }
    }
  },
}
</script>

<style></style>